import {
  Home,
  Camera,
  UserCheck,
  PaintBucket,
  Store,
  Layers,
  User,
  Sparkles,
  MessageCircle,
  Settings,
  Bell,
  Infinity,
  Grid3x3,
  Package
} from 'lucide-react';
import { NavigationItem } from './types';

// Main navigation items shared between desktop and mobile
export const mainNavItems: NavigationItem[] = [
  {
    id: 'home',
    label: 'Home',
    icon: Home,
    href: '/loops',
  },
  {
    id: 'bulletins',
    label: 'Artstream',
    icon: Camera,
    href: '/bulletins',
  },
  {
    id: 'top-follows',
    label: 'Top Follows',
    icon: UserCheck,
    href: '/top-follows',
  },
  {
    id: 'canvas',
    label: 'Canvas',
    icon: PaintBucket,
    href: '/canvas',
    disabled: true,
  },
  {
    id: 'sticker-shop',
    label: 'Sticker Shop',
    icon: Store,
    href: '/shop',
    disabled: true,
  }
];

// Desktop-only navigation items
export const desktopNavItems: NavigationItem[] = [
  ...mainNavItems,
  {
    id: 'moodboards',
    label: 'Moodboards',
    icon: Grid3x3,
    href: '/moodboards',
    disabled: false,
  },
  {
    id: 'constellations',
    label: 'Constellations',
    icon: Sparkles,
    href: '/contextboard',
    disabled: true,
  },
  {
    id: 'communities',
    label: 'Communities',
    icon: Layers,
    href: '/communities',
    disabled: false,
    children: [], // Will be populated dynamically
  },
  // HIDDEN: Not ready for public release yet
  // {
  //   id: 'drops-inventory',
  //   label: 'My Drops',
  //   icon: Package,
  //   href: '/drops/inventory',
  //   disabled: false,
  //   partnerOnly: true,
  //   badge: 'Preview',
  // },
];

// Mobile-specific navigation items 
export const mobileNavItems: NavigationItem[] = [
  {
    id: 'loops',
    label: 'Loops',
    icon: Infinity,
    href: '/loops',
  },
  {
    id: 'bulletins',
    label: 'Artstream',
    icon: Camera, 
    href: '/bulletins',
  },
  {
    id: 'communities',
    label: 'Communities',
    icon: Layers,
    href: '/communities',
    disabled: false,
  },
  {
    id: 'top-follows',
    label: 'Top Follows',
    icon: UserCheck,
    href: '/top-follows',
  },
  // HIDDEN: Not ready for public release yet
  // {
  //   id: 'drops-inventory',
  //   label: 'My Drops',
  //   icon: Package,
  //   href: '/drops/inventory',
  //   disabled: false,
  //   partnerOnly: true,
  //   badge: 'Preview',
  // },
  {
    id: 'account',
    label: 'Account',
    icon: User,
    href: '/profile',
  },
];

// Helper function to determine if a route is active
export const isRouteActive = (href: string, currentPath: string): boolean => {
  // Exact match for home
  if (href === '/' && currentPath === '/') return true;
  
  // For other routes, check if currentPath starts with href
  // But ensure we don't match partial paths (e.g. /bulletins shouldn't match /bulletins-test)
  if (href !== '/') {
    return currentPath.startsWith(href) && 
      (currentPath.length === href.length || currentPath[href.length] === '/');
  }
  
  return false;
};
